import React from 'react';
import { Row } from 'react-table';
import classNames from 'classnames';

type TableRowsProps = {
  rows: Row<object>[];
  hightlightRowOnHover?: boolean;
  hasRowDividers?: boolean;
  prepareRow: (row: Row<object>) => void;
  getRowProps: (row: Row<any>) => void;
};

export const TableRows = ({
  rows,
  hightlightRowOnHover,
  hasRowDividers,
  prepareRow,
  getRowProps,
}: TableRowsProps): JSX.Element => (
  <>
    {rows.map((row) => {
      prepareRow(row);
      return (
        <tr
          {...row.getRowProps(
            getRowProps(row) as Parameters<typeof row.getRowProps>[0]
          )}
          className={classNames({
            'bg-secondary-50': row.isSelected,
            'hover:bg-secondary-50': hightlightRowOnHover,
          })}
        >
          {row.cells.map((cell) => {
            return (
              <td
                className={classNames(
                  'py-2 text-sm text-gray-900',
                  cell.column.id === 'selection' ? 'px-2' : 'px-6',
                  {
                    'border-b border-gray-100': hasRowDividers,
                  }
                )}
                {...cell.getCellProps()}
              >
                {cell.render('Cell')}
              </td>
            );
          })}
        </tr>
      );
    })}
  </>
);
